import script from "./CreationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreationPage.vue?vue&type=script&setup=true&lang=js"

import "./CreationPage.vue?vue&type=style&index=0&id=5d8847b8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d8847b8"]])

export default __exports__